import { Form, NumberBox, SelectBox, TextBox } from 'devextreme-react';
import { ButtonItem, EmptyItem, SimpleItem } from 'devextreme-react/form';
import { Component } from 'react';
import { apiGetP, apiPostP } from '../../GanjiTools';
import { UniGrid } from '../UniGrid';
import ExportTool from './ExportTool';
import CollapsibleBox from '../utils/CollapsibleBox';
import { style } from 'typestyle';
import Theme from '../theme/Theme';
import SideDivider from '../layout/SideDivider';

class DriverReports extends Component {
    state = {
        driver: this.props.driver,
        //driversLookup: window.driversLookup ?? [],
        receivables: 0, payments: 0, moneyBalance: 0,
        loading: true,
    }

    static fetchdriversLookupP(forceReload) {
        return new Promise((resolve, reject) => {
            if (!forceReload && window.driversLookup?.length > 0) {
                resolve?.(window.driversLookup);
                return;
            }
            apiPostP('/api/dyna/rowsAsLookup/TaraDriver', {})
                .then(res => {
                    let { list, error } = res ?? { error: 'No response' };
                    if (error?.length > 0) {
                        reject?.(error);
                        return;
                    }
                    window.driversLookup = list;
                    resolve?.(list);
                    console.log('driversLookup=', driversLookup);
                }).catch(reject)
        });
    }

    loadDriverReport = id => {
        apiGetP(`/api/tarabar/report/driver/${id}`)
            .then(res => {
                let { error, receivables, payments } = res ?? { error: 'No response.' };
                if (error?.length > 0) {
                    window.notif(error);
                    return;
                }
                this.setState({ receivables, payments, moneyBalance: receivables - payments });
            })
            .catch(window.notif);
    }

    onSelectedDriverChanged = id => {
        this.setState({ driver: window.driversLookup.find(x => x.id === id) }, () => this.loadDriverReport(id));
    }

    componentDidMount() {
        DriverReports.fetchdriversLookupP(true)
            .then(() => this.setState({ loading: false }))
            .catch(console.log);
        //.then(driversLookup => this.setState({ driversLookup }));
    }

    render() {
        if (this.state.loading)
            return (
                <p style={{ padding: '3rem' }}> صبر کنید...</p>
            );

        let title = 'نمایش سوابق', summary = '', width = this.props.width ?? `${SideDivider.bodyWidth - 150}px`;

        return (
            <div style={{ padding: '0 3rem' }}>
                <CollapsibleBox className={'loadorder-collapsibleboxd ' +
                    style({
                        background: Theme.col1('whitesmoke'),
                        borderRadius: '1rem',
                        color: Theme.col0()
                    })
                }
                    style={{ width, margin: this.props.collapsed ? '2px auto' : '1rem auto' }}

                    title={
                        <div className='loadorder-title'
                            style={{
                                height: '100%', display: 'flex', color: Theme.col0('steelblue'), // ,
                                justifyContent: 'center', alignItems: 'center', fontWeight: '700',
                            }}
                        >
                            <span style={{ fontWeight: '900' }}>{title}</span>
                        </div>
                    }
                    headerStyle={{
                        width: `calc(${width} - ${this.props.wizardMode ? -2 : 2}rem)`,
                        background: Theme.col1('whitesmoke'),
                        color: Theme.col0(),
                    }}
                    summary={
                        <span className='loadorder-summary'
                            style={{
                                margin: '0 1rem',
                                fontSize: '0.8rem',
                                color: Theme.col2('#550')
                            }}
                        >
                            {!Array.isArray(summary) ? summary : Card.renderCards('', summary)}
                        </span>
                    }

                    bodyStyle={{
                        ...this.props.style, ...this.stl, marginTop: '0',
                        borderRadius: /*this.props.collapsed ? '0' :*/ '0 0 1rem 1rem',
                        width: `calc(${width} - 2rem)`,
                        background: Theme.col1('whitesmoke'),
                    }}>
                    <Form rtlEnabled colCount={60} width={`calc(${width} - 3rem)`}>
                        <SimpleItem colSpan={60} label={{ text: 'انتخاب راننده' }}>
                            <SelectBox rtlEnabled items={window.driversLookup} valueExpr='id' displayExpr='summary'
                                value={this.state.driver?.id}
                                onValueChanged={e => this.onSelectedDriverChanged(e.value)}
                            />
                        </SimpleItem>

                        <EmptyItem colSpan={60} />

                        <SimpleItem colSpan={60}>
                            <UniGrid table='Mission' readOnly noMetaGrid
                                title='مأموریت ها'
                                //field='fK_Driver' equalTo={this.state.driver?.id} field='fK_Driver' equalTo={this.state.driver?.id}
                                fieldEqualities={{ fK_Driver: `=${this.state.driver?.id ?? 0}` }}
                                hideFields={['fK_Driver']}
                            />
                        </SimpleItem>

                        <SimpleItem colSpan={60}>
                            <UniGrid table='Deal' readOnly noMetaGrid title='پرداخت ها'
                                //field='fK_Driver' equalTo={this.state.driver?.id}
                                fieldEqualities={{ fK_Driver: `=${this.state.driver?.id ?? 0}` }}
                                hideFields={['fK_Driver', 'fK_Customer', 'ware', 'date']}
                            />
                        </SimpleItem>

                        <SimpleItem label={{ text: 'مجموع مطالبات ها' }} colSpan={30}>
                            <NumberBox readOnly key={'nbi_' + this.state.receivables}
                                value={this.state.receivables ?? 0}
                            />
                        </SimpleItem>

                        <SimpleItem label={{ text: 'مجموع پرداختی ها' }} colSpan={30}>
                            <NumberBox readOnly key={'nbo_' + this.state.payments}
                                value={this.state.payments ?? 0}
                            />
                        </SimpleItem>

                        <SimpleItem label={{ text: 'تراز مالی' }} colSpan={60}>
                            <NumberBox readOnly
                                value={this.state.moneyBalance ?? 0}
                            />
                        </SimpleItem>
                    </Form>
                </CollapsibleBox>

                <div style={{ margin: '2rem 0 1rem 0', color: 'gray' }}>
                </div>

                <ExportTool table='deal' width={width} fileName='گزارش راننده'
                    excludeFields={['fK_Tanker', 'fK_Driver', 'fK_Customer', 'ware', 'dealType']}
                    extraFieldEqualities={[
                        { name: 'dealType = 1', oper: 'pre_rendered' },//{ name: 'dealType', oper: '=', value1: 1, nature: 'number' },
                        { name: 'fK_Driver = ' + this.state.driver?.id, oper: 'pre_rendered' } //{ name: 'fK_Driver', oper: '=', value1: this.state.driver?.id, nature: 'number' }
                    ]}
                />
            </div>
        );
    }
}

export default DriverReports;